import { render, staticRenderFns } from "./MoreFrom.vue?vue&type=template&id=ac37a0ec"
import script from "./MoreFrom.vue?vue&type=script&lang=js"
export * from "./MoreFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports